// export const convertNameToPath = (name: string) => {
//   return name.includes('-') ? name.replace(/ /g, "").toLocaleLowerCase() :
//   name.replace(/ /g, "-").toLocaleLowerCase();
// };

export const convertNameToPath = (name: string) => {
  return name.replace(/ /g, '-').toLocaleLowerCase();
};

export const convertPathToTitle = (path: string) => {
  return path
    .replace(/--+/g, 'TEMP_HYPHEN') // Replace multiple dashes with a temporary placeholder
    .replace(/-/g, ' ') // Replace single dashes with spaces
    .replace(/TEMP_HYPHEN/g, ' - ') // Replace the placeholder back with a hyphen
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
};
export enum Statuses {
  Draft = 'DRAFT',
  NotStarted = 'NOT_STARTED',
  InProgress = 'IN_PROGRESS',
  IPAtRisk = 'IN_PROGRESS_AT_RISK',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
  Delete = 'DELETED',
  SubmittedToHR = 'SUBMITTED_TO_HR',
  Closed = 'CLOSED',
  overdue = 'OVERDUE',
  NCExpired = 'NOT_COMPLETED_EXPIRED',
}

export const statusesLabel: { [key: string]: string } = {
  [Statuses.Draft]: 'Draft',
  [Statuses.NotStarted]: 'Not Started',
  [Statuses.InProgress]: 'In Progress',
  [Statuses.IPAtRisk]: 'In Progress - At Risk',
  [Statuses.Completed]: 'Completed',
  [Statuses.Cancelled]: 'Cancelled',
  [Statuses.SubmittedToHR]: 'Submitted to HR',
  [Statuses.Closed]: 'Closed',
  [Statuses.overdue]: 'Overdue',
  [Statuses.NCExpired]: 'Not Completed - Expired',
};

export const statusArray = [
  Statuses.Draft,
  Statuses.NotStarted,
  Statuses.InProgress,
  Statuses.IPAtRisk,
  Statuses.Completed,
  Statuses.Cancelled,
  Statuses.NCExpired,
];

// {
//   DRAFT,    0
//   NOT_STARTED,  1
//   IN_PROGRESS,  2
//   IN_PROGRESS_AT_RISK,  3
//   COMPLETED,  4
//   CANCELLED   5
// }

export const objectiveStatuses = [
  {
    label: 'Not Started',
    value: Statuses.NotStarted,
  },
  {
    label: 'In Progress',
    value: Statuses.InProgress,
  },
  {
    label: 'In Progress - At Risk',
    value: Statuses.IPAtRisk,
  },
  {
    label: 'Completed',
    value: Statuses.Completed,
  },
  {
    label: 'Cancelled',
    value: Statuses.Cancelled,
  },
];

export const statusColors: { [key: string]: string } = {
  [Statuses.Draft]: '#D9D9D9',
  [Statuses.NotStarted]: '#D9D9D9',
  [Statuses.InProgress]: '#1890FF',
  [Statuses.SubmittedToHR]: '#1890FF',
  [Statuses.IPAtRisk]: '#FA8C16',
  [Statuses.Completed]: '#52C41A',
  [Statuses.Cancelled]: '#65350F',
  [Statuses.Closed]: 'rgb(101,53,15)',
  [Statuses.overdue]: '#AC1313',
  [Statuses.NCExpired]: '#D9D9D9',
};

export const quarterReviewStatuses = [
  Statuses.NotStarted,
  Statuses.InProgress,
  Statuses.Completed,
  Statuses.Closed,
];

export const annualReviewStatuses = [
  Statuses.NotStarted,
  Statuses.InProgress,
  Statuses.Completed,
  Statuses.Closed,
];

export interface IUserProfilePic {
  id: string;
  file: Blob;
}

// Add metadata to localStorage, actual blobs to IndexedDB
const DB_NAME = 'userProfilesDB';
const STORE_NAME = 'profilePics';

// Initialize IndexedDB
const initDB = async () => {
  return new Promise<IDBDatabase>((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);

    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);

    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id' });
      }
    };
  });
};

export const getUserProfilesFromStorage = async () => {
  try {
    // Get metadata from localStorage
    const metadataString = localStorage.getItem('user-profile-pics-metadata');
    const metadata = metadataString
      ? JSON.parse(metadataString)
      : { lastFetchedDate: null };

    // Get blobs from IndexedDB
    const db = await initDB();
    const transaction = db.transaction(STORE_NAME, 'readonly');
    const store = transaction.objectStore(STORE_NAME);
    const profiles = await new Promise<IUserProfilePic[]>((resolve) => {
      const request = store.getAll();
      request.onsuccess = () => resolve(request.result);
    });

    return {
      data: profiles,
      lastFetchedDate: metadata.lastFetchedDate
        ? new Date(metadata.lastFetchedDate)
        : null,
    };
  } catch (error) {
    console.error('Error retrieving user profiles:', error);
    return { data: [], lastFetchedDate: null };
  }
};

export const addUserProfilesToStorage = async (
  data: IUserProfilePic[],
  lastFetchedDate: Date
) => {
  try {
    // Store metadata in localStorage
    localStorage.setItem(
      'user-profile-pics-metadata',
      JSON.stringify({
        lastFetchedDate: lastFetchedDate.toISOString(),
      })
    );

    // Store blobs in IndexedDB
    const db = await initDB();
    const transaction = db.transaction(STORE_NAME, 'readwrite');
    const store = transaction.objectStore(STORE_NAME);

    // Clear existing data
    await new Promise<void>((resolve) => {
      const request = store.clear();
      request.onsuccess = () => resolve();
    });

    // Add new data
    for (const profile of data) {
      store.add(profile);
    }
  } catch (error) {
    console.error('Error storing user profiles:', error);
  }
};
